export default __webpack_public_path__ + "static/fun-lounge-a29f6a0e20e2f39dbf4c99022c7cdf29.jpg";